var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgErrorWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1727_366)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 53.5232C42.0961 53.5232 53.5232 42.0961 53.5232 28C53.5232 13.904 42.0961 2.47685 28 2.47685C13.904 2.47685 2.47685 13.904 2.47685 28C2.47685 42.0961 13.904 53.5232 28 53.5232ZM28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 53.5232C42.0961 53.5232 53.5232 42.0961 53.5232 28C53.5232 13.904 42.0961 2.47685 28 2.47685C13.904 2.47685 2.47685 13.904 2.47685 28C2.47685 42.0961 13.904 53.5232 28 53.5232ZM28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "white",
    fillOpacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5335 28C48.5335 39.3403 39.3404 48.5333 28.0001 48.5333C16.6599 48.5333 7.4668 39.3403 7.4668 28C7.4668 16.6598 16.6599 7.46668 28.0001 7.46668C39.3404 7.46668 48.5335 16.6598 48.5335 28ZM30.8001 14.9333V31.7333H25.2001V14.9333H30.8001ZM30.8001 40.6497V35.0497H25.2001V40.6497H30.8001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5335 28C48.5335 39.3403 39.3404 48.5333 28.0001 48.5333C16.6599 48.5333 7.4668 39.3403 7.4668 28C7.4668 16.6598 16.6599 7.46668 28.0001 7.46668C39.3404 7.46668 48.5335 16.6598 48.5335 28ZM30.8001 14.9333V31.7333H25.2001V14.9333H30.8001ZM30.8001 40.6497V35.0497H25.2001V40.6497H30.8001Z",
    fill: "#D32F2F",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1727_366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgErrorWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error-white.31468f69be060b7ac85a85663f110a8a.svg";